import fs from 'fs';
import path from 'path';
import matter from 'gray-matter';
import readingTime from 'reading-time';
import { POSTS_PATH, postFilePaths } from 'utils/mdx';
import { formatTimecode } from 'utils/timecode';

export { Articles as default } from './Articles';

export function getStaticProps() {
  const allPosts = postFilePaths.map(filePath => {
    const source = fs.readFileSync(path.join(POSTS_PATH, filePath));
    const { data, content } = matter(source);

    const { time } = readingTime(content);
    const timecode = formatTimecode(time);

    return {
      ...data,
      timecode,
      slug: filePath.replace(/\.mdx?$/, ''),
      category: data.category || 'other',
      tags: data.tags || [],
    };
  });

  // Same rule as [slug]: drafts show in dev, and 404 in production.
  const published = allPosts.filter(
    post => !(process.env.NODE_ENV === 'production' && post.draft)
  );

  const featured = published.find(post => post.featured);

  const posts = published
      .filter(post => !featured || post.slug !== featured.slug)
      .sort((a, b) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
      })
      .reverse();

  return {
    props: { posts, featured: featured || null },
  };
}
